import clsx from 'clsx'
import React from 'react'

export type InnerPageProps = {
	children: React.ReactNode
	className?: string
}

const InnerPage = ({ children, className }: InnerPageProps) => {
	return (
		<div className={clsx('pl-5 pr-5 pb-20 pt-5', className)}>
			{children}
		</div>
	)
}

export default InnerPage
